module.exports = __webpack_public_path__ + "static/img/2.b98c67d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/zh/2.png
// module id = P5Jn
// module chunks = 0